/**
 * @file 平台事件总线
 * @description 提供平台内通用事件的发布与订阅能力。
 */
import EventEmitter from 'eventemitter3';

import type {PointsRechargeSuccessPayload} from '@/constants/actionEvents';

export const PLATFORM_EVENT_NAMES = {
    POINTS_RECHARGE_SUCCESS: 'pointsRechargeSuccess',
} as const;

interface PlatformEventPayloadMap {
    [PLATFORM_EVENT_NAMES.POINTS_RECHARGE_SUCCESS]: PointsRechargeSuccessPayload;
}

type PlatformEventName = keyof PlatformEventPayloadMap;

type PlatformEventListener<K extends PlatformEventName> = (
    payload: PlatformEventPayloadMap[K],
) => void;

const emitter = new EventEmitter();

export const platformEventBus = {
    emit<K extends PlatformEventName>(eventName: K, payload: PlatformEventPayloadMap[K]): void {
        emitter.emit(eventName, payload);
    },

    on<K extends PlatformEventName>(eventName: K, listener: PlatformEventListener<K>): () => void {
        emitter.on(eventName, listener as never);
        return () => {
            emitter.off(eventName, listener as never);
        };
    },
};
